import type { Catalog } from "./catalog.js";

// Galician. Emergency register, plain language.
// Completed in E3 — full coverage of en.ts (enforced by test/i18n-coverage.test.ts).
export const gl: Catalog = {
  "app.name": "Beacon",
  // Onboarding — Promise
  "onboarding.promise.tagline": "Veciños que avisan veciños.",
  "onboarding.promise.proof.corroboration": "×14 corroboracións de media por alerta",
  "onboarding.promise.proof.time": "menos de 90 s ata unha alerta corroborada",
  "onboarding.promise.proof.nosignup": "0 contas, números de teléfono ou rexistros necesarios",
  "onboarding.promise.continue": "Comezar",
  "onboarding.promise.restore": "Recuperar a miña identidade",
  "onboarding.promise.step": "BENVIDA",
  // Onboarding — Permissions (JIT-honest)
  "onboarding.perms.step": "PASO 2 / 3",
  "onboarding.perms.title": "Como che pide permiso Beacon",
  "onboarding.perms.location": "A localización só serve para vixiar a túa zona. Pedímoscho a primeira vez que centras o mapa.",
  "onboarding.perms.notifications": "As notificacións levan as alertas. Pedímoscho a primeira vez que as activas.",
  "onboarding.perms.background": "A actualización en segundo plano mantén as alertas a tempo. Opcional, pídese en contexto.",
  "onboarding.perms.later": "Configurar máis tarde",
  "onboarding.perms.continue": "Continuar",
  // Onboarding — Home
  "onboarding.home.step": "PASO 3 / 3",
  "onboarding.home.title": "Onde está a túa zona?",
  "onboarding.home.radius": "Radio de vixilancia",
  "onboarding.home.km": "{n} km",
  "onboarding.home.pickHint": "Move o mapa para que o pin marque este lugar.",
  "onboarding.home.confirm": "Vixiar esta zona",
  "onboarding.home.browse": "Polo de agora, só explorar",
  "onboarding.home.locating": "Buscando a túa localización…",
  "onboarding.home.located": "Marcador na túa localización actual — axústao se fai falta.",
  "onboarding.home.unavailable": "Localización non dispoñible — move o mapa ata a túa casa.",
  // Now tab — status
  "now.meta": "{place} · {radius} km",
  "now.meta.ago": "hai {m} min",
  "now.meta.justNow": "agora mesmo",
  "now.meta.none": "aínda sen eventos",
  "now.meta.net": "rede {v}",
  "now.meta.netDown": "rede —",
  "now.meta.info.title": "Que significan estes números",
  "now.meta.info.radius": "{radius} km — o raio de vixilancia da túa zona.",
  "now.meta.info.area": "{area} — cando chegou o último evento da túa zona (incidente, propagación, tempo ou axuda).",
  "now.meta.info.net": "rede {net} — cando se inxeriu o último evento en toda a rede, de calquera fonte ou veciño en Europa. Se isto avanza e o teu non, a rede funciona e simplemente non ten novidades para ti.",
  "now.meta.info.feeds": "Fontes detrás do que ves: {feeds}.",
  "now.place.default": "a túa zona",
  "region.unsupported.title": "Fóra da rexión cartografada",
  "region.unsupported.body": "Aínda non hai teselas de mapa para esta localización.",
  "now.status.step": "AGORA",
  "now.status.allClear": "Todo tranquilo.",
  "now.status.stayAware": "Mantente atento.",
  "now.status.nearby.fire": "Lume preto.",
  "now.status.nearby.flood": "Inundación preto.",
  "now.status.nearby.earthquake": "Terremoto sentido.",
  "now.status.nearby.conflict": "Perigo preto.",
  "now.status.nearby.other": "Risco preto.",
  "now.status.nearby.traffic": "Corte de tráfico preto.",
  "now.status.nearby.storm": "Tormenta preto.",
  "now.status.nearby.snow": "Neve preto.",
  "now.status.nearby.ice": "Xeo nas estradas preto.",
  "now.status.nearby.heat": "Aviso de calor extremo.",
  "now.status.nearby.fog": "Néboa densa preto.",
  "now.status.nearby.hazmat": "Alerta de materiais perigosos preto.",
  "now.status.nearby.outage": "Corte de subministración preto.",
  "now.status.sub": "{distance} km · {place}",
  "now.status.sub.allClear": "Nada activo dentro do teu radio de vixilancia.",
  // Now tab — community strip
  "now.community.neighbors": "{n} veciños",
  "now.community.watching": "VIXIANDO",
  "now.community.helpers": "{n} axudantes",
  "now.community.helpersLabel": "PRETO",
  "now.community.median": "<90s",
  "now.community.medianLabel": "ATA ALERTA CORROBORADA",
  "now.community.corroborated": "×{n}",
  "now.community.corroboratedLabel": "CORROBORADO",
  // Now tab — activity + report
  "now.activity.title": "PRETO",
  "now.activity.empty": "Nada preto agora mesmo.",
  "now.pulse.live": "Rede activa — último evento hai {s} s",
  "now.pulse.quiet": "Rede en calma desde hai {m} min",
  "now.pulse.unreachable": "Non se pode contactar co relay",
  "now.pulse.area": "A túa zona: último aviso hai {m} min",
  "now.pulse.areaNone": "A túa zona: aínda sen avisos",
  "now.zone.addHere": "Estás fóra dos teus lugares vixiados — engadir aquí como zona?",
  "now.activity.corroboration": "CORROBORADO ×{n}",
  "now.group.areas": "{n} zonas",
  "now.group.expand": "Amosar zonas",
  "now.report.button": "Informar",
  "now.recenter": "Recentrar en min",
  "now.fitAll": "Ver todos os lugares",
  "now.raw.toggle": "Informes brutos",
  "now.raw.list.title": "Informes ({n})",
  "now.raw.list.more": "+{n} máis",
  "now.raw.detail": "{hazard} · vía {feed} · {time}",
  "now.report.title": "Informe",
  "now.report.unverified": "Informe sen verificar — aínda non corroborado",
  "now.report.event": "Evento",
  "now.report.response": "Resposta",
  "now.report.severity": "Gravidade",
  "now.report.observed": "Observado",
  "now.report.source": "Fonte",
  "now.warning.viewSource": "Ver aviso completo ↗",
  // Report sheet — corroborate mode
  "report.corroborate.title": "Corroborar",
  "report.corroborate.q": "É o {hazard} preto de {place}?",
  "report.corroborate.yes": "Si, tamén o vexo",
  "report.corroborate.no": "Non, isto é diferente",
  // Report sheet — full flow
  "report.title": "Informar dun risco",
  "report.step.what": "Que pasa?",
  "report.step.where": "Onde?",
  "report.step.howbad": "Como de grave?",
  "report.where.here": "Aquí (a túa zona)",
  "report.where.honesty": "Compártese como o teu barrio, non o teu enderezo.",
  "report.where.pick": "Escolle un punto no mapa",
  "report.where.pickHint": "Arrastra o mapa para que o marcador quede no sitio.",
  "report.where.current": "Localización actual",
  "report.where.home": "Casa",
  "report.where.pin": "Marcar no mapa",
  "report.where.selected": "Informar en",
  "report.where.locating": "Localizando…",
  "report.where.locateFailed": "Non se puido obter a túa localización — informando desde a casa.",
  "report.note.placeholder": "Engade unha liña (opcional)",
  "report.next": "Seguinte",
  "report.back": "Atrás",
  "report.submit": "Enviar o informe",
  "report.cancel": "Cancelar",
  "report.severity.label": "Gravidade",
  // Report sheet — confirmation
  "report.done.title": "Enviado",
  "report.done.body": "Agora é visible para os veciños. As alertas saltan cando outros o corroboran.",
  "report.done.close": "Feito",
  "report.error": "Non se puido enviar — podes tentalo de novo.",
  // Hazards (controlled vocab)
  "hazard.fire": "Lume",
  "hazard.flood": "Inundación",
  "hazard.earthquake": "Terremoto",
  "hazard.conflict": "Perigo",
  "hazard.other": "Risco",
  "hazard.traffic": "Tráfico", "hazard.storm": "Tormenta", "hazard.snow": "Neve",
  "hazard.ice": "Xeo", "hazard.heat": "Calor", "hazard.fog": "Néboa",
  "hazard.hazmat": "Materiais perigosos", "hazard.outage": "Corte de subministración",
  // Chrome
  "tab.now": "Agora",
  "tab.help": "Axuda",
  "tab.you": "Ti",
  "tab.talk": "Conversa",
  "tab.beacon": "Axustes de Beacon",
  "beacon.tab.step": "AXUSTES",
  "beacon.tab.title": "Beacon",
  // Talk tab
  "talk.scope.area": "A miña zona",
  "talk.scope.region": "Rexión ampliada",
  "talk.region.size": "Tamaño da rexión: ~{km} km",
  "talk.band.area": "na túa zona",
  "talk.band.region": "a túa rexión · ~{km} km",
  "talk.band.distant": "distante",
  "talk.you": "Ti",
  "talk.empty": "Aínda non hai mensaxes. Saúda á túa zona.",
  "zone.checking": "Comprobando a túa zona…",
  "zone.stalled": "Aínda sen conexión coa rede — seguimos tentando…",
  "zone.progress.windows": "historial {done}/{total}",
  "zone.progress.attempts": "intento {done}/{total}",
  "zone.retry": "Tentar de novo",
  "talk.placeholder.locked": "🔒 mensaxe non dispoñible",
  "talk.composer.placeholder": "Escribe á túa zona…",
  "talk.composer.send": "Enviar",
  "talk.new.count": "{n} novas ↓",
  "talk.zone.home": "Home",
  "talk.zone.nearby": "Nearby",
  "talk.compose.noCell": "Waiting for this place's location…",
  "banner.simulation": "SIMULACIÓN",
  "locale.switch": "Idioma",
  // Alert receipt — toast/takeover (C4)
  "alert.toast.new": "{hazard} informado preto",
  "alert.toast.escalation": "O {hazard} preto agravouse",
  "alert.toast.inPath": "O {hazard} agora avanza cara a ti",
  "alert.toast.reAlert": "{hazard} preto — actualización",
  "alert.toast.allClear": "Todo tranquilo preto de {place}",
  "alert.toast.sub": "{distance} km · {place}",
  "alert.toast.tap": "Toca para ver detalles e pasos de seguridade",
  "alert.toast.more": "+{n} máis",
  "alert.severity.info": "AVISO",
  "alert.severity.warning": "ADVERTENCIA",
  "alert.severity.critical": "CRÍTICO",
  "alert.takeover.title": "{hazard} — actúa agora",
  "alert.takeover.sub": "{distance} km de {place}",
  "alert.takeover.steps": "PASOS DE SEGURIDADE",
  "alert.takeover.details": "Ver todos os detalles",
  "alert.takeover.dismiss": "Descartar",
  "alert.takeover.dismissNext": "Descartar e ver o seguinte · {n} máis",
  // IncidentDetail (C4)
  "incident.detail.metrics.corroborated": "×{n}",
  "incident.detail.reports.title": "Informes detrás disto ({n})",
  "incident.detail.metrics.corroboratedLabel": "CORROBORADO",
  "incident.detail.metrics.first": "{ago}",
  "incident.detail.metrics.firstLabel": "PRIMEIRO INFORME",
  "incident.detail.metrics.spread": "{status}",
  "incident.detail.metrics.spreadLabel": "PROPAGACIÓN",
  "incident.detail.spread.moving": "Avanza ~{speed} km/h",
  "incident.detail.spread.stationary": "Estacionario",
  "incident.detail.spread.dissipating": "Amainando",
  "incident.detail.spread.unknown": "—",
  "incident.detail.steps": "PASOS DE SEGURIDADE",
  "incident.detail.directions": "Como chegar",
  "incident.detail.share": "Compartir",
  "incident.detail.help": "Podo axudar",
  "incident.detail.helpSoon": "A coordinación de axuda chegará pronto.",
  "incident.detail.flag": "Informar dun problema con esta alerta",
  "incident.detail.flagSoon": "Os informes de problemas chegarán pronto.",
  "incident.detail.back": "Atrás",
  "incident.detail.away": "{hazard} — a {n} km",
  "incident.detail.ago.min": "hai {n} min",
  "incident.detail.ago.hr": "hai {n} h",
  "incident.detail.ago.now": "agora mesmo",
  // IncidentDetail — details block (origin / how bad / status) + corroborate
  "incident.detail.meta.title": "DETALLES",
  "incident.detail.meta.origin": "Orixe",
  "incident.detail.meta.severity": "Gravidade",
  "incident.detail.meta.status": "Estado",
  "incident.detail.origin.crowd": "Comunidade",
  "incident.detail.origin.authority": "Oficial",
  "incident.severity.1": "Leve",
  "incident.severity.2": "Serio",
  "incident.severity.3": "Grave",
  "incident.status.open": "Activo",
  "incident.status.sustained": "En curso",
  "incident.status.closing": "Diminuíndo",
  "incident.status.closed": "Pechado",
  "incident.detail.seeIt": "Eu tamén o vexo",
  "incident.detail.seeItDone": "Grazas: o teu informe engadiuse.",
  "incident.detail.tab.safety": "Seguridade",
  "incident.detail.tab.details": "Detalles",
  "incident.detail.tab.actions": "Accións",
  "incident.detail.helpBrowse": "Ver peticións de axuda",
  // Safety steps — tone-invariant, per hazard (GUI §3)
  "safety.fire.1": "Marcha cedo — non agardes a ver as chamas.",
  "safety.fire.2": "Vai contra o vento e cara arriba do fume.",
  "safety.fire.3": "Leva auga, medicación e o teléfono.",
  "safety.fire.4": "Se quedas atrapado, busca terreo limpo ou un edificio.",
  "safety.flood.1": "Vai a un lugar máis alto agora.",
  "safety.flood.2": "Nunca camiñes nin conduzas por auga en movemento.",
  "safety.flood.3": "Corta a corrente se a auga sobe dentro da casa.",
  "safety.flood.4": "Mantente lonxe de ríos, sumidoiros e pontes.",
  "safety.earthquake.1": "Agáchate, protéxete e agarra ata que pare o tremor.",
  "safety.earthquake.2": "Mantente lonxe de fiestras e mobles pesados.",
  "safety.earthquake.3": "Despois do tremor, comproba fugas de gas e danos.",
  "safety.earthquake.4": "Agarda réplicas — prepárate para protexerte de novo.",
  "safety.conflict.1": "Afástate do perigo e busca refuxio.",
  "safety.conflict.2": "Mantente baixo e con paredes sólidas entre ti e o perigo.",
  "safety.conflict.3": "Comparte o teu estado con alguén de confianza.",
  "safety.conflict.4": "Segue as indicacións de emerxencia locais.",
  "safety.other.1": "Afástate do risco inmediato.",
  "safety.other.2": "Avisa os veciños que quizais non o viron.",
  "safety.other.3": "Segue as indicacións de emerxencia locais.",
  "safety.traffic.1": "Reduce a velocidade e manten máis distancia.",
  "safety.traffic.2": "Segue os sinais e fusiónate cedo no carril.",
  "safety.traffic.3": "Considera unha ruta alternativa.",
  "safety.storm.1": "Queda dentro e lonxe das xanelas.",
  "safety.storm.2": "Evita viaxar ata que pase.",
  "safety.storm.3": "Asegura os obxectos soltos no exterior.",
  "safety.storm.4": "Afástate de árbores e tendidos eléctricos.",
  "safety.snow.1": "Evita desprazamentos non esenciais.",
  "safety.snow.2": "Abrígate ben e manten o teléfono cargado.",
  "safety.snow.3": "Despexa as saídas e comproba os veciños.",
  "safety.ice.1": "Ten coidado nas estradas e camiños.",
  "safety.ice.2": "Reduce a velocidade e frea con suavidade.",
  "safety.ice.3": "Usa calzado con aderencia.",
  "safety.heat.1": "Bebe auga a miúdo.",
  "safety.heat.2": "Queda á sombra ou en lugares frescos.",
  "safety.heat.3": "Evita o esforzo ao mediodía.",
  "safety.heat.4": "Comproba o estado de maiores e persoas vulnerables.",
  "safety.fog.1": "Reduce a velocidade e usa luz de cruce.",
  "safety.fog.2": "Manten máis distancia.",
  "safety.fog.3": "Evita as adelantamentos.",
  "safety.hazmat.1": "Entra nun local e pecha xanelas e ventilacións.",
  "safety.hazmat.2": "Evita a zona afectada.",
  "safety.hazmat.3": "Segue as instrucións oficiais.",
  "safety.outage.1": "Aforras batería do teléfono.",
  "safety.outage.2": "Usa lanternas, non velas.",
  "safety.outage.3": "Comproba os veciños que poidan necesitar axuda.",
  "offline.strip": "SEN CONEXIÓN · ÚLTIMA SINC. {time}",
  // Help tab — need types (controlled vocab)
  "need.medical": "Médica",
  "need.rescue": "Rescate",
  "need.transport": "Transporte",
  "need.shelter": "Acubillo",
  "need.supplies": "Subministracións",
  "need.hands": "Mans",
  "need.other": "Outros",
  // Help tab — status block (GUI §4)
  "help.status.step": "AXUDA",
  "help.status.some": "{n} persoas precisan axuda preto.",
  "help.status.one": "1 persoa precisa axuda preto.",
  "help.status.none": "Non hai solicitudes abertas preto.",
  "help.status.sub": "Máis preto: {need} · {distance} km",
  "help.status.subNone": "Aquí verás as peticións abertas da túa zona.",
  // Helper mode card
  "help.helper.toggle": "Podo axudar",
  "help.helper.intro": "Ofrece axuda aos veciños preto de ti.",
  "help.helper.tagsLabel": "En que podes axudar?",
  "help.helper.ttlLabel": "Durante canto tempo?",
  "help.helper.ttl.today": "Hoxe",
  "help.helper.ttl.week": "Esta semana",
  "help.helper.ttl.incident": "Durante este incidente",
  "help.helper.area": "Só a túa zona — localización aproximada, nunca o teu enderezo.",
  "help.helper.register": "Rexistrar a dispoñibilidade",
  "help.helper.registered": "Estás dispoñible para axudar. Mostrarémosche as peticións preto.",
  "help.helper.tierUnknown": "CONFIANZA · medra a medida que axudas e te avalan",
  // Requests near you (matcher A7 push, private SSE)
  "help.nearby.title": "Solicitudes preto de ti",
  "help.nearby.toast": "Alguén preto precisa de {need}",
  "help.nearby.empty": "Aínda sen coincidencias: avisarémoste.",
  "help.offer.toast": "Alguén ofreceuse a axudar",
  "help.accept.error": "Aínda non se puido aceptar: sincronizando esa persoa. Téntao de novo nun momento.",
  // Open requests list
  "help.list.title": "PETICIÓNS ABERTAS",
  "help.list.empty": "Non hai peticións abertas na túa zona.",
  "help.list.verified": "◆",
  // Request detail + offer/accept (GUI §4)
  "help.detail.back": "Atrás",
  "help.detail.needLabel": "Precisa {need}",
  "help.detail.urgencyLabel": "URXENCIA",
  "help.detail.location": "Só zona aproximada",
  "help.detail.honesty": "O enderezo exacto só se comparte se aceptan a túa oferta.",
  "help.detail.offer": "Ofrecer axuda",
  "help.detail.submitOffer": "Enviar a oferta",
  "help.detail.notePlaceholder": "Engade unha nota (opcional)",
  "help.detail.etaPlaceholder": "Tempo de chegada en minutos (opcional)",
  "help.detail.offersTitle": "OFERTAS",
  "help.detail.offersEmpty": "Aínda non hai ofertas. Os veciños verán esta petición.",
  "help.detail.accept": "Aceptar",
  "help.detail.accepted": "Aceptada",
  "help.detail.acceptCaveat": "Aceptar comparte a túa localización exacta con esa persoa: non se verifica a súa identidade e non se pode desfacer.",
  "help.detail.offerSent": "Oferta enviada. Avisarémoste se a aceptan.",
  // Create request sheet
  "help.create.button": "Pedir axuda",
  "help.create.title": "Pedir axuda",
  "help.create.step.need": "Que precisas?",
  "help.create.step.what": "Que fai falta?",
  "help.create.step.urgency": "Que urxencia?",
  "help.create.headlinePlaceholder": "Unha liña — que precisas?",
  "help.create.peoplePlaceholder": "Cantas persoas?",
  "help.create.urgencyLabel": "URXENCIA",
  "help.create.next": "Seguinte",
  "help.create.back": "Atrás",
  "help.create.submit": "Publicar a petición",
  "help.create.error": "Non se puido publicar. Téntao de novo.",
  "help.create.done.title": "Petición publicada.",
  "help.create.done.body": "Os veciños preto xa a poden ver e ofrecer axuda.",
  "help.create.done.close": "Feito",
  // My activity
  "help.activity.title": "A TÚA ACTIVIDADE",
  "help.activity.mine": "A túa petición",
  "help.activity.helping": "Estás axudando",
  "help.activity.offered": "Ofreciches axuda",
  "help.activity.pending": "Aínda non está na rede",
  "help.screen.resolvedDone": "Resolto — marcado como feito.",
  "help.screen.resolvedCancelled": "Esta solicitude cancelouse.",
  "help.screen.loading": "Cargando a solicitude…",
  "help.activity.activeTitle": "ACTIVAS",
  "help.activity.resolvedTitle": "RESOLTAS",
  "help.activity.badge.done": "Feito",
  "help.activity.badge.cancelled": "Cancelada",
  "help.activity.badge.active": "Activa",
  // Coordination thread (GUI §4, §6)
  "help.thread.back": "Atrás",
  "help.thread.title": "Coordinación",
  "help.thread.precise": "Localización compartida",
  "help.thread.preciseSelf": "A túa localización compartida",
  "help.thread.heartbeat": "{name} · {state}",
  "help.thread.composePlaceholder": "Mensaxe…",
  "help.thread.send": "Enviar",
  "help.thread.done": "Feito",
  "help.thread.cantMake": "Non podo ir",
  "help.thread.you": "Ti",
  "help.thread.requester": "Quen pide",
  "help.thread.helper": "Axudante · {id}",
  "help.thread.resend": "Reenviar",
  "help.thread.empty": "Coordinade aquí. As mensaxes están cifradas para todos nesta solicitude.",
  "help.thread.openMap": "Abrir mapa ↗",
  "help.confirm.cancel": "Cancelar",
  "help.confirm.done.title": "Marcar como resolta?",
  "help.confirm.done.body": "Avísase a quen axuda e pasa a Resoltas.",
  "help.confirm.done.confirm": "Marcar feita",
  "help.confirm.cant.title": "Retirar a túa axuda?",
  "help.confirm.cant.body": "A solicitude reábrese para outras persoas preto.",
  "help.confirm.cant.confirm": "Retirar",
  "help.status.chip.open": "Aberta",
  "help.status.chip.accepted": "Aceptada",
  "help.status.chip.enroute": "De camiño",
  "help.status.chip.arrived": "Chegou",
  "help.status.chip.partial": "Parcial",
  "help.status.chip.done": "Feita",
  "help.status.chip.cancelled": "Cancelada",
  // Lifecycle step labels (numbered-steps)
  "help.lifecycle.open": "Aberta",
  "help.lifecycle.offered": "Ofrecida",
  "help.lifecycle.accepted": "Aceptada",
  "help.lifecycle.enroute": "En camiño",
  "help.lifecycle.arrived": "Chegou",
  "help.lifecycle.done": "Feito",
  // You tab (GUI §5)
  "you.step": "TI",
  "you.title": "Ti e a túa configuración",
  // Location & alerts
  "you.loc.title": "LOCALIZACIÓN E ALERTAS",
  "you.loc.home": "Zona da casa",
  "you.loc.setHome": "Definir a localización da casa",
  "you.loc.coords": "Coordenadas",
  "you.loc.change": "Cambiar a zona da casa",
  "you.loc.setHomeHint": "Escolle unha zona da casa para ver o mapa e recibir alertas do que tes preto.",
  "you.loc.radius": "Radio de vixilancia",
  "you.loc.km": "{n} km",
  "you.loc.quiet": "Horas de silencio",
  "you.loc.quietValue": "{start}:00 – {end}:00",
  "you.loc.quietOff": "Desactivado",
  "you.loc.quietToggle": "Silenciar as alertas non críticas pola noite",
  "you.loc.autoDismiss": "Descartar avisos despois de",
  "you.loc.autoDismiss.seconds": "{n}s",
  "you.loc.autoDismiss.never": "Permanecer ata descartar",
  "you.loc.minsev": "Gravidade mínima para alertar",
  "you.loc.addPlace": "Engadir outro lugar",
  "you.loc.addCurrent": "Usar a localización actual",
  "you.loc.liveFollow": "Seguir a miña localización",
  "you.loc.liveFollowHint": "Avísate de perigos onde estás mentres Beacon está aberto. Usa máis batería; desactivado por defecto.",
  "you.loc.liveFollowUnavailable": "O acceso á localización está desactivado. Actívao no navegador para seguir a túa localización.",
  "you.loc.keepAwake": "Manter a pantalla acesa ao seguir",
  "you.loc.keepAwakeHint": "Mantén a pantalla activa durante o seguimento en directo para non perder ningunha alerta. Se o desactivas, un dispositivo durmido non te pode avisar: unha limitación das aplicacións web.",
  "you.sound.title": "Son de alerta",
  "you.sound.hint": "Reproduce un ton breve coa voz que elixiches cando aparece unha alerta. Desactivado ata que o actives; sempre en silencio durante as horas de silencio.",
  "you.sound.preview": "Reproducir mostra",
  "you.loc.travelRadius": "Radio en ruta",
  "you.loc.places": "LUGARES VIXIADOS",
  "you.loc.placeUnnamed": "Lugar gardado",
  "you.loc.removePlace": "Quitar",
  "now.watched.title": "Outros lugares vixiados",
  "now.watched.alert": "Incendio preto de {place}",
  "you.loc.editPlace": "Editar",
  "you.loc.placeName": "Nome",
  "you.loc.homeName": "Nome da casa",
  "you.loc.moveUp": "Subir",
  "you.loc.moveDown": "Baixar",
  // Voice (supporter-locked)
  "you.voice.title": "VOZ",
  "you.voice.intro": "Escolle como che fala Beacon.",
  "you.voice.official": "Oficial",
  "you.voice.human": "Humana",
  "you.voice.dark": "Humor negro",
  "you.voice.deadpan": "Impasible",
  "you.voice.nonna": "Avoa",
  "you.voice.preview.official": "Incendio forestal informado 3 km ao norte. Corroborado por 14 veciños.",
  "you.voice.preview.human": "Hai un lume xusto ao norte de ti — os teus veciños tamén o ven.",
  "you.voice.preview.dark": "Lume ao norte. Tan bo momento como calquera para estrear esas zapatillas.",
  "you.voice.preview.deadpan": "Lume ao norte. Anotado.",
  "you.voice.preview.nonna": "Hai un lume xusto ao norte, cariño — vai xa, fálocho en serio.",
  // Trust
  "you.trust.title": "CONFIANZA",
  "you.trust.tier": "O teu nivel",
  "you.trust.tierUnknown": "— alimentado polo proxector (D2)",
  "you.trust.how": "Como medra: antigüidade da conta, informes confirmados e avais.",
  "you.trust.factor.age": "Antigüidade da conta",
  "you.trust.factor.confirmed": "Informes confirmados",
  "you.trust.factor.vouches": "Avais",
  "you.trust.factorValue": "— alimentado polo proxector (D2)",
  "you.trust.vouch": "Avalar un veciño",
  "you.trust.vouchHint": "Comparte esta ligazón en persoa con alguén de confianza.",
  "you.trust.vouchers": "Os teus avalistas",
  "you.trust.vouchersEmpty": "— alimentado polo proxector (D2)",
  "you.trust.backup": "Copia e rotación de claves",
  "you.trust.export": "Descargar o meu ficheiro de recuperación",
  "you.trust.exportHint": "Este ficheiro é a túa conta. Gárdao nun lugar seguro e privado.",
  "you.trust.import": "Restaurar desde un ficheiro de recuperación",
  "you.trust.rotate": "Rotar as miñas claves",
  "you.trust.rotateHint": "Substitúe as túas claves de sinatura. Descarga despois un ficheiro de recuperación novo.",
  "you.trust.rotated": "Claves rotadas. Descarga agora o teu novo ficheiro de recuperación.",
  "you.trust.importBad": "Ese ficheiro non é un ficheiro de recuperación de Beacon válido.",
  "you.trust.importOk": "Ficheiro de recuperación aceptado. Usarase a próxima vez que abras a app.",
  "you.trust.capability.direct": "Os teus informes alertan a túa zona directamente.",
  "you.trust.capability.needsConfirm": "Neste momento un veciño precisa confirmar o teu informe antes de alertar a zona.",
  "you.trust.capability.full": "Os teus informes xa teñen peso total. As alertas maiores aínda precisan que algúns veciños as confirmen — así é como Beacon mantén a confianza.",
  "you.trust.progress.confirmed": "Con {confirmed} informe(s) confirmado(s) máis, os teus informes terán máis peso.",
  "you.trust.progress.days": "Continúa usando Beacon durante uns {days} día(s) máis para gañar reputación.",
  // Privacy
  "you.privacy.title": "PRIVACIDADE",
  "you.privacy.consentTitle": "O que aceptaches",
  "you.consent.alerts": "Recibir alertas da miña zona",
  "you.consent.helperAvailability": "Compartir a miña dispoñibilidade para axudar",
  "you.consent.preciseLocationRelease": "Liberar a localización precisa cando acepte unha petición",
  "you.consent.publicMetrics": "Contribuír a métricas públicas anónimas",
  "you.privacy.export": "Exportar os meus datos",
  "you.privacy.exportHint": "Unha copia portátil de todo o que hai neste dispositivo.",
  "you.privacy.erase": "Borrarme",
  "you.privacy.eraseHint": "Borrado criptográfico: as túas claves destrúense e os teus datos apáganse en todas partes.",
  // Seguridade e privacidade — que protexe o chat de axuda e os seus límites.
  "you.safety.title": "SEGURIDADE E PRIVACIDADE",
  "you.safety.intro": "Que se protexe cando pides ou ofreces axuda, e onde están os límites.",
  "you.safety.toggle": "Como se protexe a túa seguridade",
  "you.safety.e2ee.h": "As mensaxes están cifradas de extremo a extremo",
  "you.safety.e2ee.d": "Só ti e a persoa coa que te coordinas podedes lelas: nin Beacon nin o relé.",
  "you.safety.location.h": "A túa localización exacta queda privada ata que aceptas",
  "you.safety.location.d": "Quen axuda só ve a túa zona aproximada. En canto aceptas a alguén, só esa persoa recibe a túa localización precisa.",
  "you.safety.metadata.h": "A rede pode ver que te estás a coordinar",
  "you.safety.metadata.d": "As túas palabras e a localización exacta están ocultas, pero si que se ve que estás a recibir axuda, a túa zona aproximada e o momento. Trata o teu barrio como público.",
  "you.safety.identity.h": "Non se verifica a identidade de quen axuda",
  "you.safety.identity.d": "Calquera pode ofrecer axuda con calquera nome. Comparte datos sensibles só cando teñas claro con quen tratas.",
  "you.safety.irrevocable.h": "Compartir a túa localización precisa non se pode desfacer",
  "you.safety.irrevocable.d": "Unha vez que aceptas, esa persoa garda a localización que compartiches. Non hai volta atrás.",
  "you.safety.forwardSecrecy.h": "As mensaxes antigas dependen da seguridade do teu dispositivo",
  "you.safety.forwardSecrecy.d": "Beacon aínda non usa unha clave nova para cada mensaxe, así que unha clave roubada podería expoñer chats pasados. Mantén o teléfono bloqueado.",
  "you.safety.retention.h": "As mensaxes caducan, pero non as podes borrar",
  "you.safety.retention.d": "As mensaxes de coordinación desaparecen soas ao cabo dun tempo. Aínda non hai borrado manual mensaxe a mensaxe.",
  // Erase confirmation (grave)
  "you.erase.title": "Borrarte de Beacon?",
  "you.erase.body": "Isto destrúe as claves que desbloquean todo o que compartiches. Os informes e mensaxes que xa están nos teléfonos dos veciños non se poden retirar, pero todo o demais apágase para sempre. Isto non se pode desfacer.",
  "you.erase.confirmLabel": "Escribe BORRAR para confirmar",
  "you.erase.confirmWord": "BORRAR",
  "you.erase.cancel": "Manter a miña conta",
  "you.erase.confirm": "Borrarme",
  "you.erase.done": "A túa petición de borrado está asinada e en camiño. Adeus.",
  // Support Beacon
  // App
  "you.app.title": "APP",
  "you.app.language": "Idioma",
  "you.app.notifications": "Notificacións",
  "you.app.notificationsOn": "Activadas",
  "you.app.notificationsOff": "Desactivadas",
  "you.notif.enabled": "Notificacións activadas. Avisarémoste aínda que o Beacon estea pechado.",
  "you.notif.denied": "As notificacións están bloqueadas. Permíteas na configuración do navegador para recibires avisos co Beacon pechado.",
  "you.notif.unsupported": "Este navegador non pode amosar notificacións co Beacon pechado. As alertas dentro da app seguen funcionando.",
  "you.notif.nopush": "Notificacións permitidas, pero o envío aínda non está configurado neste servidor. As alertas dentro da app seguen funcionando.",
  "you.notif.subfail": "Notificacións permitidas, pero este dispositivo non puido activar o envío. As alertas dentro da app seguen funcionando.",
  "you.notif.subfail.noservice": "Notificacións permitidas, pero este dispositivo non ten servizo de envío (p. ex. sen Google Play). As alertas dentro da app funcionan; para as de segundo plano usa Chrome ou a vindeira app de Beacon.",
  "you.notif.dismissed": "Sen avisos co Beacon pechado ata que permitas as notificacións. Actívaas cando queiras.",
  "you.app.about": "Acerca de Beacon",
  "you.app.version": "Versión piloto",
  // Flags & appeals (only if non-empty)
  "you.flags.title": "OS TEUS AVISOS E RECURSOS",
  // E2 moderation — flag sheet
  "flag.title": "Informar dun problema",
  "flag.intro": "Os avisos son privados. Nunca se lle di ao autor quen avisou.",
  "flag.reason.falseReport": "Falso ou enganoso",
  "flag.reason.spam": "Lixo",
  "flag.reason.harassment": "Acoso",
  "flag.reason.dangerousAdvice": "Consello perigoso",
  "flag.reason.harvestAttempt": "Intento de recoller localizacións",
  "flag.reason.doxxing": "Doxxing / datos persoais",
  "flag.reason.illegal": "Contido ilegal",
  "flag.reason.other": "Outra cousa",
  "flag.submit": "Enviar o aviso",
  "flag.done": "Grazas — os moderadores botaranlle unha ollada.",
  "flag.error": "Non se puido enviar. Téntao de novo.",
  // E2 moderation — You transparency surface
  "you.flags.empty": "Aquí non hai nada. Ningunha acción sobre os teus informes.",
  "you.flags.actionLabel": "Acción sobre a túa actividade",
  "you.flags.weight": "Móstrase máis abaixo na clasificación",
  "you.flags.reversible": "Isto é reversible e temporal. Podes presentar un recurso.",
  "you.flags.appeal": "Recorrer isto",
  "you.flags.expires": "Caduca o {date}",
  // E2 moderation — appeal sheet
  "appeal.title": "Recurso",
  "appeal.intro": "Explica por que se debería reverter. Un moderador revísao.",
  "appeal.statement.placeholder": "Por que é incorrecto?",
  "appeal.submit": "Enviar o recurso",
  "appeal.done": "Recurso enviado. Verás o resultado aquí.",
  "appeal.error": "Non se puido enviar o recurso. Téntao de novo.",
  // E9 incident detail — trend / freshness / source / advanced (Task 3)
  "incident.detail.meta.lastConfirmed": "Última confirmación",
  "incident.detail.meta.wind": "Vento",
  "incident.detail.meta.trend": "Tendencia",
  "incident.detail.meta.sources": "Fontes",
  "incident.detail.trend.rising": "Intensificándose",
  "incident.detail.trend.steady": "Estable",
  "incident.detail.trend.falling": "A diminuír",
  "incident.detail.worsening": "Empeorando",
  "incident.detail.adv.title": "Avanzado",
  "incident.detail.adv.intensity": "Potencia radiativa",
  "incident.detail.adv.mw": "{n} MW",
  "incident.detail.adv.peak": "(pico {n} MW)",
  "incident.detail.adv.trendAxes": "Detalle da tendencia",
  "incident.detail.adv.weight": "Peso de corroboración",
  "incident.detail.adv.identities": "Autoridades confirmadoras",
  "incident.detail.adv.axis.rising": "↑",
  "incident.detail.adv.axis.steady": "→",
  "incident.detail.adv.axis.falling": "↓",
  "incident.detail.wind": "{speed} km/h de {dir}",
  "compass.n": "N",
  "compass.ne": "NE",
  "compass.e": "E",
  "compass.se": "SE",
  "compass.s": "S",
  "compass.sw": "SO",
  "compass.w": "O",
  "compass.nw": "NO",
  "incident.source.nasa-firms": "NASA FIRMS",
  "incident.source.fogos.pt": "fogos.pt",
  "incident.source.anepc": "ANEPC",
  "now.activity.confirmedAgo": "confirmado {ago}",
  "now.activity.worsening": "▲ intensificándose",
  // Install pointer (M3)
  "you.get.title": "INSTALA BEACON NO MÓBIL",
  "you.get.body": "Instala Beacon para recibir alertas aínda que estea pechado.",
  "you.get.cta": "Obter Beacon",
  "install.title": "Instala Beacon no móbil",
  "install.desktop.intro": "Beacon avísate de perigos próximos aínda que a páxina estea pechada.",
  "install.desktop.scan": "Escanea para abrir Beacon no móbil.",
  "install.ios.intro": "Instala Beacon para recibir alertas aínda que estea pechado.",
  "install.ios.step.share": "Toca o botón Compartir.",
  "install.ios.step.add": "Escolle «Engadir á pantalla de inicio».",
  "install.ios.step.open": "Abre Beacon desde a pantalla de inicio.",
  "install.ios.note": "Sen tenda de aplicacións, nada que descargar.",
  "install.android.intro": "Instala Beacon para recibir alertas aínda que estea pechado.",
  "install.android.install": "Instalar Beacon",
  "install.android.apk": "APK autoaloxado (sen Google)",
  "install.hint.title": "Instalar Beacon",
  "install.hint.body": "Recibe alertas aínda que Beacon estea pechado.",
  "install.hint.cta": "Instalar",
  "install.hint.dismiss": "Rexeitar",
  // You-tab cleanup (field card + disclosures)
  "you.card.trusted": "Veciño de confianza",
  "you.card.building": "Gañando confianza",
  "you.card.neighbor": "Veciño",
  "you.card.watch": "vixilancia de {n} km",
  "you.card.noHome": "Sen zona de casa definida",
  "you.loc.alertDetail": "Axustar alertas",
  "you.loc.livePosition": "Posición en directo",
  "you.loc.level.off": "Desactivado",
  "you.loc.level.info": "Info",
  "you.loc.level.warning": "Aviso",
  "you.loc.level.critical": "Crítico",
  "you.trust.howToggle": "Como funciona a confianza",
  "you.trust.keysToggle": "Chaves e recuperación",
  "you.privacy.dataToggle": "Os teus datos",
  "you.card.id": "ID de Beacon",
  "you.loc.homeTitle": "CASA E LUGARES",
  "you.loc.alertsTitle": "ALERTAS",
  "you.loc.removeConfirm": "Quitar?",
  "you.loc.cancel": "Cancelar",
  // Advanced — raw-report layer (power-user opt-in)
  "you.raw.title": "Informes brutos (avanzado)",
  "you.raw.toggle": "Mostrar informes individuais no mapa",
  "you.raw.warning": "Os informes brutos teñen moito máis volume que os incidentes confirmados e consumen máis datos e batería. Activar de todos xeitos?",
  "you.raw.depth.label": "Ata onde cargar",
  "you.raw.depth.off": "Só en directo",
  "you.raw.depth.shallow": "Superficial",
  "you.raw.depth.medium": "Medio",
  "you.raw.depth.deep": "Profundo",
  // Advanced — spread-cone debug cells (authoritative H3 overlay)
  "you.cone.title": "Celas do cono (avanzado)",
  "you.cone.toggle": "Mostrar as celas exactas do motor de alertas",
  "you.cone.helper": "Superpón as celas H3 autoritativas que o motor de alertas usa para decidir quen está na traxectoria dun perigo: útil para comprobar por que chegou ou non unha alerta.",

  "commons.card.title": "O común",
  "commons.card.thisPeriod": "Este período",
  "commons.card.runRate": "Custo recorrente fronte ás achegas",
  "commons.card.cumulative": "Histórico",
  "commons.card.oneTime": "Puntual (p. ex. desenvolvemento)",
  "commons.card.yourCost": "A túa parte xusta ata agora",
  "commons.card.yourGiven": "Achegaches",
  "commons.card.operatorStated": "declarado polo operador",
  "commons.card.chipIn": "Achegar",
  "commons.card.chippedIn": "Xa fixeches a túa achega este mes — grazas.",
  "commons.card.need": "Beacon precisou {amount} este mes para avisarte.",
  "commons.card.viewTransparency": "Ver transparencia",
  "commons.card.deficit": "Déficit",
  "commons.card.surplus": "Superávit",
  "commons.card.empty": "Aínda non hai actividade do común.",
  "commons.chipIn.title": "Achega ao común",
  "commons.chipIn.pickToken": "Escolle que enviar",
  "commons.chipIn.amount": "Importe (opcional)",
  "commons.chipIn.getAddress": "Obter enderezo",
  "commons.chipIn.address": "Envía a este enderezo",
  "commons.chipIn.copy": "Copiar enderezo",
  "commons.chipIn.copied": "Copiado",
  "commons.chipIn.deadline": "Paga en {min} min para que se che acredite. Os pagamentos tardíos tamén axudan ao común, pero non se amosarán na túa tarxeta.",
  "commons.chipIn.oneClick": "Pagar coa carteira conectada",
  "commons.chipIn.noWallet": "Non se detectou ningunha carteira no navegador: escanea ou pega o enderezo.",
  "commons.chipIn.sent": "Transacción enviada",
  "commons.chipIn.error": "Non se puido obter un enderezo. Téntao de novo.",
  "commons.chipIn.intro": "Unha achega puntual para os custos de funcionamento desta instancia — na cadea, sen rexistro.",
  "commons.chipIn.network": "Envía en {network}",
  "commons.chipIn.wrongChain": "Envía só nesta rede: os fondos noutra cadea non se poden detectar.",
  "commons.chipIn.afterTitle": "Despois de enviar",
  "commons.chipIn.afterDetect": "O teu depósito detéctase automaticamente na cadea: non tes que facer nada máis.",
  "commons.chipIn.afterAppear": "Cando a rede o confirme (normalmente un ou dous minutos), aparecerá no común e na túa tarxeta se pagaches dentro do prazo.",
  "commons.chipIn.done": "Feito",
  "commons.chipIn.close": "Pechar",
  "commons.received": "Achega recibida. Grazas!",
  "commons.chipIn.waiting": "Agardando o teu depósito na cadea…",
  "commons.chipIn.receivedTitle": "Achega recibida",
  "commons.chipIn.receivedBody": "Grazas por achegar: xa está no libro do común.",
  "commons.privacy.hidden": "Oculto para todos",
  "commons.privacy.public": "Oculto en público, visto brevemente por esta instancia",
  "commons.privacy.custodial": "O teu banco/provedor ve isto",
  "commons.transparency.title": "Transparencia do común",
  "commons.transparency.intro": "Calculado por completo a partir de eventos asinados no firehose. Calquera pode reproducilo de xeito independente.",
  "commons.transparency.series": "Custo recorrente fronte ás achegas, por período",
  "commons.transparency.oneTimeSeries": "Custos puntuais, por período",
  "commons.transparency.projection": "Este período (estimación, rateo)",
  "commons.transparency.history": "Historial ata o xénese",
  "commons.transparency.basis": "Base do denominador",
  "commons.transparency.reproduce": "Reprodúceo desde o firehose: cada dato é un evento asinado de custo ou achega.",
  "commons.transparency.colCost": "Custo recorrente",
  "commons.transparency.colContrib": "Achegas",
  "commons.transparency.colNet": "Neto",
  "commons.transparency.colOneTime": "Puntual",
  "commons.transparency.estimate": "estimación",
};
